import React from 'react';
import logo from '../../assets/logo-no-background.png'; // adjust the path as needed
import './Logo.css';

const Logo = () => (
  <img src={logo} alt="Logo" className="logo" />
);

export default Logo;